import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom'
import LandingPage from "./ui/main/LandingPage";
import {LoginQuickGuide} from "./ui/main/quickGuide/login/LoginQuickGuide";
import {CreateReservationQuickGuide} from "./ui/main/quickGuide/createReservation/CreateReservationQuickGuide";
import {ConfirmReservationQuickGuide} from "./ui/main/quickGuide/confirmReservation/ConfirmReservationQuickGuide";
import {CloseReservationQuickGuide} from "./ui/main/quickGuide/closeReservation/CloseReservationQuickGuide";
import {ShowMapFromReservationDetailQuickGuide} from "./ui/main/quickGuide/showFloorMap/ShowMapFromReservationDetailQuickGuide";
import {ShowMapFromCreateReservationQuickGuide} from "./ui/main/quickGuide/showFloorMap/ShowMapFromCreateReservationQuickGuide";

class App extends React.Component {
    render() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={LandingPage}/>
                    <Route exact path="/quickGuide/login" component={LoginQuickGuide}/>
                    <Route exact path="/quickGuide/createReservation" component={CreateReservationQuickGuide}/>
                    <Route exact path="/quickGuide/confirmReservation" component={ConfirmReservationQuickGuide}/>
                    <Route exact path="/quickGuide/closeReservation" component={CloseReservationQuickGuide}/>
                    <Route exact path="/quickGuide/reservationDetail/openFloorMap" component={ShowMapFromReservationDetailQuickGuide}/>
                    <Route exact path="/quickGuide/createReservation/openFloorMap" component={ShowMapFromCreateReservationQuickGuide}/>
                </div>
            </Router>
        )
    }
}

ReactDOM.render(
    <App/>,
    document.getElementById('app')
);
